import React, { Component } from "react";
import { connect } from "react-redux";
import Opportunity from "./common/Opportunity";
import { notificationAction } from "../../../actions";
import { StorageService } from "../../../api";
import { privateRoutes, publicRoutes } from "../../../Routes/routing";
import { logoutAction } from "../../../store/initialConfig";
import { RESET_LANDINGPAGE_URL } from "../../../utilities/enviroments";
import { logoutApi } from "../../../components/Navigation/navigationApi";
import { parse } from "uuid";

class OpportunityNew extends Component {
  componentDidMount = () => {
    const spliturl = this.props.location.pathname.match(/\d+/g);
    if (spliturl) {
      const user = JSON.parse(localStorage.getItem("User"));
      const userId = parseInt(spliturl[1]);
      if (user.UserId !== userId)
        logoutApi().then((response) => {
          this.props.history.push("new-opportunity");
          if (response.success) {
            this.props.logoutAction();
            const info = {
              message: "Please login with your appropriate account.",
              status: "error",
            };
            this.props.notificationAction(info);
            StorageService.clearAll();
            window.location.href = RESET_LANDINGPAGE_URL;
            return;
          }
        })
    }
  }
  render() {
    const { labels, notificationAction, location, isHelpActive } = this.props;
    const {
      Invitation_Empty,
      iproOpportunityNewSearchField,
      TooltipIproOpportunityNewListCollapse,
      HlpTooltipIproOpportunityNewListCollapse,
      ViewTitleInvitationList,
      iproOpportunityNewDetailsHeading,
      ToolTipInvitationExpandDetail,
      HlpTooltipIproOpportunityNewDetailExpand,
      ToolTipInvitationCollaspeDetail,
      HlpTooltipIproOpportunityNewDetailCollapse,
      ViewTitleInvitationDetail,
      iproOpportunityNewCompanyDetailHeading,
      ToolTipCompanyExpandDetail,
      HlpTooltipIproOpportunityNewUserDetailExpand,
      ToolTipCompanyCollaspeDetail,
      HlpTooltipIproOpportunityNewUserDetailCollapse,
      ViewTitleCompanyDetail,
      ToolTipInvitationExpandList,
      HlpTooltipIproOpportunityNewListExpand,
      iProOpportunityNewDetailLblHeading,
      iProOpportunityNewDetailLblLocation,
      iProOpportunityNewDetailLblStartDate,
      iProOpportunityNewDetailLblDuration,
      iProOpportunityNewDetailLblCompany,
      iProOpportunityNewDetailLblDescription,
      iProOpportunityNewDetailLblSearchParameterHeading,
      iProOpportunityNewDetailLblProfile,
      iProOpportunityNewDetailLblSkills,
      iProOpportunityNewDetailLblKeyword,
      iProOpportunityNewDetailLblIndustry,
      iProOpportunityNewDetailLblCertification,
      iProOpportunityNewDetailLblCountry,
      iProOpportunityNewDetailLblInterest,
      iProOpportunityNewDetailBtnAccept,
      iProOpportunityNewDetailBtnDecline,
      iProOpportunityNewDetailLblLanguage,
      iProOpportunityNewDetailLblTitle,
      IproOpportunityNewCompanyAddressLabel,
      IproOpportunityNewCompanyIndustryLabel,
      IproOpportunityNewCompanyCountryLabel,
      IproOpportunityNewCompanyPhoneLabel,
      IproOpportunityNewCompanyWebUrlLabel,
      IproOpportunityNewCompanyVatLabel,
      iproInvitationSuccessfullyDeleted
    } = labels;
    return (
      <Opportunity
        url={`?type=3`}
        isAccepted={true}
        isNewOpportunityView
        opportunityType="NewRequests"
        IsSearcher={false}
        isHelpActive={isHelpActive}
        notificationAction={notificationAction}
        // list section system label
        Lbltitle={iProOpportunityNewDetailLblTitle}
        locationsLabel={iProOpportunityNewDetailLblLocation}
        startDateLabel={iProOpportunityNewDetailLblStartDate}
        durationLabel={iProOpportunityNewDetailLblDuration}
        companyLabel={iProOpportunityNewDetailLblCompany}
        descriptionLabel={iProOpportunityNewDetailLblDescription}
        countryLabel={iProOpportunityNewDetailLblCountry}
        SearchParameterHeading={
          iProOpportunityNewDetailLblSearchParameterHeading
        }
        LblProfile={iProOpportunityNewDetailLblProfile}
        LblSkills={iProOpportunityNewDetailLblSkills}
        LblKeyword={iProOpportunityNewDetailLblKeyword}
        LblIndustry={iProOpportunityNewDetailLblIndustry}
        LblCertification={iProOpportunityNewDetailLblCertification}
        LblCountry={iProOpportunityNewDetailLblCountry}
        LblLanguage={iProOpportunityNewDetailLblLanguage}
        LblInterest={iProOpportunityNewDetailLblInterest}
        BtnAccept={iProOpportunityNewDetailBtnAccept}
        BtnDecline={iProOpportunityNewDetailBtnDecline}
        companyAddressLabel={IproOpportunityNewCompanyAddressLabel}
        companyIndustryLabel={IproOpportunityNewCompanyIndustryLabel}
        companyCountryLabel={IproOpportunityNewCompanyCountryLabel}
        companyPhoneLabel={IproOpportunityNewCompanyPhoneLabel}
        companyWebUrlLabel={IproOpportunityNewCompanyWebUrlLabel}
        companyVatLabel={IproOpportunityNewCompanyVatLabel}
        searchInputPlaceholder={iproOpportunityNewSearchField}
        toolTipExpandList={ToolTipInvitationExpandList}
        helpTooltipExpandList={HlpTooltipIproOpportunityNewListExpand}
        toolTipCollapseList={TooltipIproOpportunityNewListCollapse}
        helpTooltipCollapseList={HlpTooltipIproOpportunityNewListCollapse}
        listColumnText={ViewTitleInvitationList}
        // detail section system label
        detailHeadingText={iproOpportunityNewDetailsHeading}
        toolTipExpandDetail={ToolTipInvitationExpandDetail}
        helpTooltipExpandDetail={HlpTooltipIproOpportunityNewDetailExpand}
        toolTipCollapseDetail={ToolTipInvitationCollaspeDetail}
        helpTooltipCollapseDetail={HlpTooltipIproOpportunityNewDetailCollapse}
        detailsColumnText={ViewTitleInvitationDetail}
        // selected user detail and company section system label
        userDetailHeadingText={iproOpportunityNewCompanyDetailHeading}
        toolTipExpandUserDetail={ToolTipCompanyExpandDetail}
        helpTooltipExpandUserDetail={
          HlpTooltipIproOpportunityNewUserDetailExpand
        }
        toolTipCollapseUserDetail={ToolTipCompanyCollaspeDetail}
        helpTooltipCollapseUserDetail={
          HlpTooltipIproOpportunityNewUserDetailCollapse
        }
        userDetailsColumnText={ViewTitleCompanyDetail}
        emptyOpportunityInfo={Invitation_Empty}
        listCollapsedTestId={"listCollapsedTestId1"}
        listCollapsedHelpTestId={"listCollapsedTestId2"}
        listExpandTestId={"listCollapsedTestId3"}
        listExpandHelpTestId={"listCollapsedTestId4"}
        detailCollapsedTestId={"listCollapsedTestId5"}
        detailCollapsedHelpTestId={"listCollapsedTestId6"}
        detailExpandTestId={"listCollapsedTestId7"}
        detailExpandHelpTestId={"listCollapsedTestId8"}
        userDetailCollapsedTestId={"listCollapsedTestId9"}
        userDetailCollapsedHelpTestId={"listCollapsedTestId10"}
        userDetailExpandTestId={"listCollapsedTestId11"}
        userDetailExpandHelpTestId={"listCollapsedTestId12"}
        searchInputTestId="opportunity-new-search-input"
        iproOpportunityListItem="iproOpportunityListItem-New"
        iproInvitationSuccessfullyDeleted={iproInvitationSuccessfullyDeleted}
        locationProp={location}
      />
    );
  }
}

const mapStateToProps = ({ systemLabel, userInfo, navigation }) => {
  const { labels } = systemLabel;
  const { user } = userInfo;
  const { isHelpActive } = navigation;
  let { UserId, IsFreelancer } = user;
  UserId =
    UserId !== undefined ? UserId : parseInt(sessionStorage.getItem("userId"));
  IsFreelancer =
    IsFreelancer !== undefined
      ? IsFreelancer
      : JSON.parse(localStorage.getItem("IsFreelancer"));
  return {
    labels,
    userId: UserId,
    IsSearcher: !IsFreelancer,
    IsFreelancer,
    isHelpActive
  };
};

const actions = { notificationAction, logoutAction };
export default connect(
  mapStateToProps,
  actions
)(OpportunityNew);
